/** 与 React ref 形状一致，避免本文件依赖 react */
export type ScreenWakeLockRef = { current: WakeLockSentinel | null }

export function isScreenWakeLockSupported(): boolean {
    return typeof navigator !== 'undefined' && navigator.wakeLock != null
}

export function isWakeLockHeld(ref: ScreenWakeLockRef): boolean {
    return ref.current !== null
}

export function releaseScreenWakeLock(ref: ScreenWakeLockRef): void {
    const sentinel = ref.current
    if (!sentinel) {
        return
    }
    ref.current = null
    void sentinel.release()
}

/**
 * 须在用户手势（点击/触摸等）中调用；不支持或拒绝时静默失败。
 */
export async function requestScreenWakeLock(ref: ScreenWakeLockRef): Promise<void> {
    if (ref.current || !isScreenWakeLockSupported()) {
        return
    }
    try {
        const sentinel = await navigator.wakeLock.request('screen')
        ref.current = sentinel
        sentinel.addEventListener('release', () => {
            if (ref.current === sentinel) {
                ref.current = null
            }
        })
    } catch {
        // NotAllowedError、非安全上下文等
    }
}
